import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { faEnvelopesBulk } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { sendReviewNotifications } from '../../../../bridge';
import { __ } from '../../../../helpers/translations';

function SendReviewNotificationsButton({ review, onChanged, disabled }) {
  const [showModal, setShowModal] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const onClickSend = async () => {
    setInProgress(true);
    await sendReviewNotifications(review.reviewId);
    setInProgress(false);
    setShowModal(false);
    onChanged();
  };

  return (
    <>
      <Button
        title={__('G131')}
        size="md"
        variant="light"
        onClick={() => setShowModal(true)}
        disabled={disabled || inProgress}
      >
        <FontAwesomeIcon icon={faEnvelopesBulk} />
      </Button>
      <Modal show={showModal} centered onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title>{__('G131')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {__('G180')}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowModal(false)}>
            {__('G106')}
          </Button>
          <Button variant="primary" disabled={inProgress} onClick={onClickSend}>
            {__('G107')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

SendReviewNotificationsButton.propTypes = {
  review: PropTypes.shape({
    reviewId: PropTypes.string.isRequired,
  }),
  onChanged: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SendReviewNotificationsButton;
